import React from 'react';
import RadioGroup from '@material-ui/core/RadioGroup';


function RenderRadioGroup(props) {
    const { input, ...rest } = props;
    return (
        <RadioGroup
            {...input}
            {...rest}
            onChange={(event, value) => input.onChange(value)}
        />
    )
}

export default RenderRadioGroup

